import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Image from '@nubank/nuds-web/components/Image/Image';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

function SectionLockedDeposits({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Box
      tag="section"
      paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
      paddingVertical={{ xs: '12x', md: '20x' }}
      display={{ lg: 'grid' }}
      gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
      gridColumnGap={{ lg: '8x' }}
      alignItems={{ lg: 'center' }}
    >
      <Box gridColumn={{ lg: '2 / 8' }}>
        <Typography variant="title" intlKey={`cms.accountPage.cardsArea[${index}].title`} marginBottom={{ xs: '6x' }} />
        {formatMessage({
          id: `cms.accountPage.cardsArea[${index}].description`,
        }, {
          strong: props => (
            <Typography
              color="primary.default"
              tag="strong"
              variant="subtitle"
              {...props}
            />
          ),
          p: props => <Typography variant="subtitle" marginBottom={{ xs: '12x', lg: '0x' }} {...props} />,
        })}
      </Box>
      <Box
        gridColumn={{ lg: '8 / 12' }}
        display="flex"
        justifyContent="center"
      >
        <Box maxWidth={{ xs: '265px', md: '300px' }}>
          <Image
            marginHorizontal="auto"
            altIntlKey="REQUEST.PIX.IMAGE_ALT"
            loading="lazy"
            srcSet={{
              xs: {
                '1x': 'locked-deposits/locked-deposits@1x.jpg',
                '2x': 'locked-deposits/locked-deposits@2x.jpg',
                '3x': 'locked-deposits/locked-deposits@3x.jpg',
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

SectionLockedDeposits.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionLockedDeposits);
